(() => {
  if (window.__ougistRegistrationLinkFix) return;
  window.__ougistRegistrationLinkFix = true;

  const normalizeLinks = () => {
    document.querySelectorAll('a[href*="product-registration"]').forEach((link) => {
      const href = link.getAttribute('href') || '';
      if (!href.includes('/pages/product-registration')) return;
      const nextHref = href
        .replace('/pages/product-registration.html', '/pages/warranty-registration')
        .replace('/pages/product-registration', '/pages/warranty-registration');
      link.setAttribute('href', nextHref);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeLinks, { once: true });
  } else {
    normalizeLinks();
  }

  new MutationObserver(normalizeLinks).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
